import { AxiosResponse } from "axios";
import { QUERY_CLIENT } from "..";
import { QueryKeys } from "./base/react-query";
import CompanySetting from "../model/product copy";
import { getAxiosInstance } from "./api-utils";
const COMPANY_SETTINGS = "/company-settings";

export async function getCompanySettings(skipErrorToast = false): Promise<CompanySetting> {
    const response: AxiosResponse<CompanySetting> = await getAxiosInstance({ skipErrorInterceptor: skipErrorToast }).get(COMPANY_SETTINGS);
    return response.data;
}

export async function updateCompanySettings(companySetting: CompanySetting) {
    await getAxiosInstance().patch(`${COMPANY_SETTINGS}`, companySetting);
    QUERY_CLIENT.invalidateQueries(QueryKeys.companySettings);
}